const REQUIRED_FIELDS_ENUM = {
  EMAIL: 'email',
  DOCUMENT: 'document',
  HOME_PHONE: 'home_phone',
  MOBILE_PHONE: 'mobile_phone',
  ADDRESS: 'address'
}

export default REQUIRED_FIELDS_ENUM
